"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
var Card = /** @class */ (function () {
    function Card(title, description, priority) {
        this.title = title;
        this.description = description;
        this.priority = priority;
    }
    Card.prototype.changeTitle = function (newTitle) {
        this.title = newTitle;
    };
    Card.prototype.changeDescription = function (newDescription) {
        this.description = newDescription;
    };
    Card.prototype.changePriority = function (newPriority) {
        this.priority = newPriority;
    };
    return Card;
}());
exports.Card = Card;
